import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookmarkJob } from '@doda/common/src/types/apiResponse/bookmarkJobs';
import { RootState } from '../store';

interface BookmarkAppealModalState {
  groupNo: string;
  jobs: BookmarkJob[];
  isPopupTarget: boolean;
}

export const bookmarkAppealModalInitialState: BookmarkAppealModalState = {
  groupNo: '0',
  jobs: [],
  isPopupTarget: false,
};

export const bookmarkAppealModalSlice = createSlice({
  name: 'bookmarkAppealModal',
  initialState: bookmarkAppealModalInitialState,
  reducers: {
    setBookmarkAppealModalGroupNo: (state, action: PayloadAction<string>) => {
      state.groupNo = action.payload;
    },
    setBookmarkAppealModalJobs: (
      state,
      action: PayloadAction<BookmarkJob[]>
    ) => {
      state.jobs = action.payload;
    },
    setBookmarkAppealModalIsPopupTarget: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isPopupTarget = action.payload;
    },
    resetBookmarkAppealModal: (state) => {
      state.groupNo = '0';
      state.jobs = [];
      state.isPopupTarget = false;
    },
  },
});

export const {
  setBookmarkAppealModalGroupNo,
  setBookmarkAppealModalJobs,
  setBookmarkAppealModalIsPopupTarget,
  resetBookmarkAppealModal,
} = bookmarkAppealModalSlice.actions;

export const bookmarkAppealModalReducer = bookmarkAppealModalSlice.reducer;

export const bookmarkAppealModalSelector = (state: RootState) =>
  state.bookmarkAppealModal;

export const bookmarkAppealModalGroupNoSelector = (state: RootState) =>
  state.bookmarkAppealModal.groupNo;

export const bookmarkAppealModalJobsSelector = (state: RootState) =>
  state.bookmarkAppealModal.jobs;

export const bookmarkAppealModalIsPopupTargetSelector = (state: RootState) =>
  state.bookmarkAppealModal.isPopupTarget;
